/* Toolbar Actions
/* ---------------------------------------------------------- */

export function initToolbarActions() {

    // ── Bookmark button ──────────────────────────────────────
    const bookmarkBtn = document.querySelector('.gh-toolbar-btn[aria-label="Bookmark post"]');
    if (bookmarkBtn) {
        const STORAGE_KEY = 'gh-bookmarks';
        const postUrl = window.location.pathname;

        function getBookmarks() {
            try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
            catch (e) { return []; }
        }

        function setBookmarked(active) {
            bookmarkBtn.classList.toggle('is-bookmarked', active);
            bookmarkBtn.setAttribute('aria-label', active ? 'Remove bookmark' : 'Bookmark post');
            bookmarkBtn.setAttribute('title', active ? 'Bookmarked' : 'Bookmark');
        }

        // Restore saved state on page load
        setBookmarked(getBookmarks().includes(postUrl));

        bookmarkBtn.addEventListener('click', function () {
            const bookmarks = getBookmarks();
            const idx = bookmarks.indexOf(postUrl);
            if (idx === -1) {
                bookmarks.push(postUrl);
                setBookmarked(true);
            } else {
                bookmarks.splice(idx, 1);
                setBookmarked(false);
            }
            localStorage.setItem(STORAGE_KEY, JSON.stringify(bookmarks));
        });
    }

    // ── More-options (···) dropdown ──────────────────────────
    const moreBtn = document.querySelector('.gh-toolbar-btn[aria-label="More options"]');
    if (moreBtn) {
        // Build dropdown element
        const dropdown = document.createElement('div');
        dropdown.className = 'gh-toolbar-dropdown';
        dropdown.setAttribute('role', 'menu');
        dropdown.innerHTML = `
            <button class="gh-toolbar-dropdown-item" data-action="copy" role="menuitem">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/>
                    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
                </svg>
                Copy link
            </button>
            <button class="gh-toolbar-dropdown-item" data-action="print" role="menuitem">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="6 9 6 2 18 2 18 9"/>
                    <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/>
                    <rect x="6" y="14" width="12" height="8"/>
                </svg>
                Print article
            </button>
        `;

        // Wrap the button so we can position the dropdown relative to it
        const wrap = document.createElement('div');
        wrap.className = 'gh-toolbar-more-wrap';
        moreBtn.parentNode.insertBefore(wrap, moreBtn);
        wrap.appendChild(moreBtn);
        wrap.appendChild(dropdown);

        moreBtn.setAttribute('aria-haspopup', 'true');
        moreBtn.setAttribute('aria-expanded', 'false');

        function openDropdown() {
            dropdown.classList.add('is-open');
            moreBtn.setAttribute('aria-expanded', 'true');
        }

        function closeDropdown() {
            dropdown.classList.remove('is-open');
            moreBtn.setAttribute('aria-expanded', 'false');
        }

        moreBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
        });

        dropdown.addEventListener('click', function (e) {
            const item = e.target.closest('[data-action]');
            if (!item) return;

            if (item.dataset.action === 'copy') {
                navigator.clipboard.writeText(window.location.href).then(() => {
                    const original = item.innerHTML;
                    item.textContent = '✓ Copied!';
                    setTimeout(() => { item.innerHTML = original; }, 2000);
                });
            } else if (item.dataset.action === 'print') {
                window.print();
            }

            closeDropdown();
        });

        // Close when clicking anywhere outside
        document.addEventListener('click', closeDropdown);

        // Close on Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeDropdown();
        });
    }
}
